import { authHeader } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8003';

// ============================================================
// 1. ESTADÍSTICAS DE USUARIOS
// ============================================================
export async function obtenerEstadisticasUsuarios() {
  const response = await fetch(`${API_URL}/api/v1/admin/dashboard/estadisticas-usuarios`, {
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al obtener estadísticas de usuarios');
  }

  return response.json();
}

// ============================================================
// 2. RESUMEN DE WAVESPEED
// ============================================================
export async function obtenerResumenWavespeed() {
  const response = await fetch(`${API_URL}/api/v1/admin/dashboard/resumen-wavespeed`, {
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al obtener resumen de Wavespeed');
  }

  return response.json();
}

// ============================================================
// 3. CONSUMO DE CRÉDITOS (AGREGADO)
// ============================================================
export async function obtenerConsumoCreditos(mes = null) {
  let url = `${API_URL}/api/v1/admin/dashboard/consumo-creditos`;
  if (mes) {
    url += `?mes=${mes}`;
  }

  const response = await fetch(url, {
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al obtener consumo de créditos');
  }

  return response.json();
}

// ============================================================
// 4. ALERTAS DEL SISTEMA
// ============================================================
export async function obtenerAlertas() {
  const response = await fetch(`${API_URL}/api/v1/admin/dashboard/alertas`, {
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al obtener alertas');
  }

  return response.json();
}

// ============================================================
// 5. 🔥 NUEVO: RESUMEN DE PAGOS (MENSUAL)
// ============================================================
export async function obtenerPagosResumen() {
  const response = await fetch(`${API_URL}/api/v1/admin/dashboard/pagos-resumen`, {
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al obtener resumen de pagos');
  }

  return response.json();
}